<template>
  <Page>
    <template v-slot:page-header>
      <div class="container">
        <div class="page-header">
          <div class="title-container">
            <div class="title">
              <div class="header-container">
                <div class="title-header">สร้างรายการ</div>
              </div>
            </div>
          </div>
          <div class="actions">
            <small class="text-danger mr-3"
              v-if="getServerError()">
              {{getServerError()}}
            </small>
            <span v-if="isSaving">
              <i class="fa fa-spin fa-spinner mr-1" />
              <small class="mr-2">
                กำลังบันทึก
              </small>
            </span>
            <button
              type="submit"
              class="btn btn-primary"
              :disabled="disableButton"
              @click.stop="onSubmit">
              บันทึก
            </button>
          </div>
        </div>
      </div>
    </template>
    <div class="container">
      <Tab>
        <div class="tab-item"
          v-for="(tabItem, tabIndex) in tabMenu"
          :key="tabIndex"
          :class="{'active': selectedTabIndex === tabIndex }"
          @click.stop="selectedTab(tabIndex)">
          {{tabItem.value}}
        </div>
      </Tab>
      <div class="tab-item tab-item-general" v-if="selectedTabIndex === 0">
        <div class="section-container">
          <SectionProgramGeneral />
        </div>
      </div>
      <div class="tab-item tab-item-information" v-if="selectedTabIndex === 1">
        <div class="section-container">
          <SectionProgramInformation />
        </div>
        <div class="section-container">
          <SectionProgramPerson />
        </div>
        <div class="section-container">
          <SectionProgramContact />
        </div>
        <div class="section-container">
          <SectionGallery />
        </div>
        <div class="section-container">
           <SectionAttachment />
        </div>
      </div>
      <div class="tab-item tab-item-general" v-if="selectedTabIndex === 2">
        <div class="section-container">
          <SectionContentImage
            @update:image="(payload) => $store.dispatch('setCurrentProgram', payload)"
            :item="currentProgram"
            :isProgram="true" />
        </div>
      </div>
      <div class="tab-item tab-item-playlist" v-if="selectedTabIndex === 3">
        <SectionProgramPlaylist />
      </div>
      <div class="tab-item tab-item-playlist" v-if="selectedTabIndex === 4">
        <SectionProgramActivityBanner />
      </div>
      <div class="tab-item tab-item-playlist" v-if="selectedTabIndex === 5">
        <SectionRelatedProgram />
      </div>
    </div>
  </Page>
</template>

<script>
import _ from 'lodash';
import { mapState, mapActions } from 'vuex';
import { updateAttachmentById } from '@/attachment/api';
import dateFormetter from '@/utils/dateFormatter';
import errorFormatter from '@/utils/errorFormatter';
import Page from '@/layouts/Page.vue';
import Tab from '@/components/Tab.vue';
import SectionProgramGeneral from '@/program/SectionProgramGeneral.vue';
import SectionProgramInformation from '@/program/SectionProgramInformation.vue';
import SectionProgramPerson from '@/program/SectionProgramPerson.vue';
import SectionProgramContact from '@/program/SectionProgramContact.vue';
import SectionProgramPlaylist from '@/program/SectionProgramPlaylist.vue';
import SectionRelatedProgram from '@/program/SectionRelatedProgram.vue';
import SectionProgramActivityBanner from '@/program/SectionProgramActivityBanner.vue';
import SectionGallery from '@/gallery/SectionGallery.vue';
import SectionAttachment from '@/attachment/SectionAttachment.vue';
import SectionContentImage from '@/image/SectionContentImage.vue';

export default {
  mixins: [dateFormetter, errorFormatter],
  components: {
    Page,
    Tab,
    SectionProgramGeneral,
    SectionProgramInformation,
    SectionProgramPerson,
    SectionProgramContact,
    SectionProgramPlaylist,
    SectionGallery,
    SectionAttachment,
    SectionContentImage,
    SectionRelatedProgram,
    SectionProgramActivityBanner,
  },
  data() {
    return {
      tabMenu: [
        {
          key: 'general',
          value: 'ข้อมูลรายการ',
        },
        {
          key: 'information',
          value: 'รายละเอียด',
        },
        {
          key: 'contentImage',
          value: 'รูปปก/โลโก',
        },
        {
          key: 'playlist',
          value: 'เพลย์ลิสต์',
        },
        {
          key: 'banner',
          value: 'แบนเนอร์กิจกรรม',
        },
        {
          key: 'relatedProgram',
          value: 'รายการที่เกี่ยวข้อง',
        },
      ],
      selectedTabIndex: 0,
    };
  },
  computed: {
    ...mapState({
      currentProgram: (state) => state.programItem.currentProgram,
      saveProgramState: (state) => state.programItem.saveProgramState,
      attachment: (state) => state.attachment.attachment,
      currentGallery: (state) => state.gallery.currentGallery,
    }),
    haveErrorMessage() {
      return _.some(this.saveProgramState.error, (value) => value);
    },
    isSaving() {
      return this.saveProgramState.status === 'saving';
    },
    disableButton() {
      return this.haveErrorMessage || this.isSaving;
    },
    getAttachment() {
      return _.get(this.currentProgram, 'attachment', null);
    },
  },
  created() {
    this.$store.dispatch('initiateCurrentProgram');
    this.$store.dispatch('resetAllGalleryState');
  },
  methods: {
    ...mapActions(['inheritAttachment']),
    async onSubmit() {
      if (this.currentProgram.attachmentId) {
        const attachmentResponse = await updateAttachmentById(this.currentProgram.attachmentId, this.attachment);
        this.inheritAttachment(attachmentResponse.data);
      }
      if (this.currentGallery.id) {
        this.currentProgram.galleryId = this.currentGallery.id;
      }
      await this.$store.dispatch('createProgram', { payload: this.currentProgram });
      this.$router.push('/programs');
    },
    getServerError() {
      return _.get(this.saveProgramState, 'error.serverError', null);
    },
    selectedTab(selectedTabIndex) {
      this.selectedTabIndex = selectedTabIndex;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';
@import './src/assets/scss/themes/components/section-container.scss';
</style>
